import { GridContext, type GridContextValue } from "@smartsuite/grid/lib/src/Grid.context";
import type { GridSettings } from "@smartsuite/grid/lib/src/Grid.types";
import type { AppField, WrappedRecord } from "@smartsuite/types";
import { type Context, useContext, useMemo } from "react";

export const useTableRowActionsPanelPosition = (record: WrappedRecord | null): number | null => {
  const { getRowPosition, scrollOptions } = useContext(
    GridContext as Context<GridContextValue<WrappedRecord, AppField, unknown, GridSettings>>,
  );

  return useMemo(() => {
    if (!record) {
      return null;
    }

    const position = getRowPosition(record);
    return position ? position.top + scrollOptions.headHeight : null;
  }, [getRowPosition, record, scrollOptions.headHeight]);
};
